import { definitionScopes } from "../model/definition.js";
export function scopeRegistry(definition) {
    const scopes = new Set();
    const collect = (values) => Object.freeze(Object.fromEntries(values.map((item) => {
        scopes.add(item.scope.id);
        return [item.id, item.scope.id];
    })));
    if (!definition.resources)
        throw new TypeError("Persistence requires a game-kit definition");
    const complete = definition;
    const resourceScopes = collect(complete.resources);
    const buyableScopes = collect(complete.buyables);
    const allocationScopes = collect(complete.allocations);
    const upgradeScopes = collect(complete.upgrades);
    const triggerScopes = collect(complete.triggers);
    const challengeScopes = collect(complete.challenges);
    const automationScopes = collect(complete.automation);
    const taskScopes = collect(complete.tasks);
    const calendarScopes = collect(complete.calendars);
    const marketScopes = collect(complete.markets);
    for (const scope of definitionScopes(definition))
        scopes.add(scope.id);
    return {
        scopes: Object.freeze([...scopes].sort()),
        resourceScopes,
        buyableScopes,
        allocationScopes,
        upgradeScopes,
        triggerScopes,
        challengeScopes,
        automationScopes,
        taskScopes,
        calendarScopes,
        marketScopes,
    };
}
//# sourceMappingURL=registry.js.map